import React from 'react'
import {
    Chart as ChartJS,
    CategoryScale,
    LinearScale,
    BarElement,
    Title,
    Tooltip,
    Legend
} from 'chart.js'
import { Card } from 'react-bootstrap';
import { Bar } from 'react-chartjs-2';

// Register ChartJS Components 
ChartJS.register(
    CategoryScale,
    LinearScale,
    BarElement,
    Title,
    Tooltip,
    Legend
);

const AttendanceChart = ({ chartData }) => {
    // Transform backend data: Site names for labels, attendance_count for data 
    const labels = chartData?.map(item => item.name) || [];
    const dataValues = chartData?.map(item => item.attendance_count) || [];

    const data = {
        labels,
        datasets: [
            {
                label: 'Officers on Duty',
                data: dataValues,
                backgroundColor: 'rgba(54, 162, 235, 0.6)', // Tracktual Blue 
                borderColor: 'rgba(54, 162, 235, 1)',
                borderWidth: 1,
                borderRadius: 5,
            }
        ]
    };

    const options = {
        indexAxis: 'y',
        responsive: true,
        maintainAspectRatio: false,
        plugins: {
            legend: {
                display: false, // Hide legend to keep it clean 
            },
            title: {
                display: false,
            },
        },
        scales: {
            y: {
                beginAtZero: true,
                ticks: {
                    stepSize: 1,
                }
            }
        }
    };
  return (
    <Card className='border-0 shadow-sm h-100'>
        <Card.Header className='bg-white border-0 py-3'>
            <h5 className='mb-0 fw-bold text-dark'>Today's Attendance by Site</h5>
        </Card.Header>
        <Card.Body>
            <div style={{ height: '300px'}}>
                {labels.length > 0 ? (
                    <Bar data={data} options={options} />
                ) : (
                    <div className="h-100 d-flex align-items-center justify-content-center text-muted">
                        No attendance data recorded today. 
                    </div>
                )}
            </div>
        </Card.Body>
    </Card>
  )
}

export default AttendanceChart